import { useTranslation } from "react-i18next";
import { MARKETING_DOMAIN_URL } from "../../core/constants/constants";
import {
  DEFAULT_LOCALE,
  getBaseLang,
  isSupportedLocale,
  withLocale,
} from "../../config/locales";

/**
 * Returns a builder that prefixes a marketing-domain path with the current
 * language. The marketing site keys on base language only (e.g. "/en", "/fr"),
 * not on full locale — so `en-GB` maps to the same "/en" marketing path.
 */
export const useLocalizedUrl = () => {
  const { i18n } = useTranslation();

  const getUrl = (path) => {
    const activeLocale = isSupportedLocale(i18n.language)
      ? i18n.language
      : DEFAULT_LOCALE;
    const baseLang = getBaseLang(activeLocale);
    return `${MARKETING_DOMAIN_URL}${withLocale(baseLang, path)}`;
  };

  return { getUrl };
};
